// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AdminScenarioContainer_wrap__2cITJ","title":"AdminScenarioContainer_title__28SlF","tableWrap":"AdminScenarioContainer_tableWrap__2kcHT"};